import { combineReducers } from 'redux'
import Builder from './components/pages/lesson/builder/redux/builder.reducer'
import LessonsList from './components/pages/lessons-list/redux/lessons.reducer'
import Lesson from './components/pages/lesson/redux/lesson.reducer'
import PupilsStore from './stores/pupils/pupils.reducer'
import GroupsStore from './stores/groups/groups.reducer'
import PresentationStore from './stores/presentation/presentation.reducer'
import WorkStore from './stores/work/work.reducer'
import SharedPresentationsStore from './stores/shared-presentations/shared-presentations.reducer'
import SharedPresentationStore from './stores/shared-presentation/shared-presentation.reducer'
import PublicPresentationStore from './stores/public-presentation/public-presentation.reducer'
import YearGroups from './stores/year-groups/year-groups.reducer'
import MyPresentationsStore from './stores/my-presentations/my-presentations.reducer'
import PresentationSearchStore from './stores/presentation-search/presentation-search.reducer'

const Reducer = combineReducers({
  MyPresentationsStore,
  LessonsList,
  Builder,
  Lesson,
  SharedPresentationsStore,
  PresentationStore,
  WorkStore,
  PupilsStore,
  GroupsStore,
  SharedPresentationStore,
  PublicPresentationStore,
  YearGroups,
  PresentationSearchStore
})

export default Reducer
